
import React from 'react';
import { User, CreditCard, LayoutGrid } from 'lucide-react';
import { UserProfileData, MenuItem } from './types';

// Get user initials for avatar fallback
export const getUserInitials = (firstName?: string, lastName?: string): string => {
  if (!firstName && !lastName) return 'U';
  
  const firstInitial = firstName?.charAt(0).toUpperCase() || '';
  const lastInitial = lastName?.charAt(0).toUpperCase() || '';
  
  return `${firstInitial}${lastInitial}` || 'U';
};

// Get full user name
export const getFullName = (userData: UserProfileData): string => {
  const { firstName, lastName } = userData;
  const first = firstName?.trim();
  const last = lastName?.trim();
  
  if (!first && !last) return 'User';
  
  return [first, last].filter(Boolean).join(' ') || 'User';
};

// Menu item click handler type
export type MenuItemClickHandler = () => void;

// Define menu items
export const getMenuItems = (): MenuItem[] => [
  { 
    name: 'Profile', 
    to: '/account', 
    icon: React.createElement(User, { size: 16, className: "group-hover:text-white transition-colors" }) 
  },
  { 
    name: 'App Library', 
    to: '/app-library', 
    icon: React.createElement(LayoutGrid, { size: 16, className: "group-hover:text-white transition-colors" }) 
  },
  { 
    name: 'Billing', 
    to: '/billing', 
    icon: React.createElement(CreditCard, { size: 16, className: "group-hover:text-white transition-colors" }) 
  }
];
